import styled from 'styled-components';

import { Button } from '../../components/Button';

export const Container = styled.div`
    > .legal {
        color: var(--color-neutral-150);
        a {
            color: var(--color-neutral-150);
            text-decoration: underline;
            cursor: pointer;
        }
    }
`;

export const LogoSection = styled.div`
    display: flex;
    align-items: center;
    * {
        margin-right: 1rem;
    }
`;

export const SubTitle = styled.p``;

export const Title = styled.h3`
    margin-top: 1rem;
`;

export const ButtonsSection = styled.div`
    display: flex;
    flex-direction: column;

    div:nth-child(1) {
        margin-bottom: 1rem;
    }
`;

export const ButtonSocialLogin = styled(Button)`
    display: flex;
    justify-content: left;

    svg {
        margin-left: 1rem;
        margin-right: 1rem;
    }

    @media (min-width: 400px) {
        svg {
            margin-left: 3.5rem;
            margin-right: 1rem;
        }
    }
`;
